import { PipeTransform, Pipe } from '@angular/core';

@Pipe({
  name: 'truncate',
})
export class TruncatePipe {
  transform(value: string, args: number): string {
    let limit = args > 0 ? args : 10;
    let trail = args > value.length ? '' : '...';
    let without_html = value.replace(/(<(?!\/)[^>]+>)+(<\/[^>]+>)+/, '').trim();
    without_html = without_html.replace(/\r?\n|\r/g, '').trim();

    if (/<[a-z][\s\S]*>/i.test(without_html)) {
      return value.length > limit
        ? without_html.substring(0, limit + 40) + trail
        : value;
    }
    return value.length > limit
      ? without_html.substring(0, limit) + trail
      : value;
  }
}
